import { BreadcrumbDefinition } from 'xng-breadcrumb/lib/types';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { SubscriptionFeatureDefinition } from '@digiwall/goliath-core/config';

const routes: Routes = [
  {
    path: 'documents',
    data: {
      breadcrumb: {
        skip: true,
      } as BreadcrumbDefinition,
    },
    canMatch: [SubscriptionFeatureDefinition],
    loadChildren: () =>
      import('../documents/customer-subscriptions/customer-subscriptions.module').then(
        m => m.CustomerSubscriptionsModule,
      ),
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GoliathDocumentsSubscriptionRoutingModule {}
